/**
 * Shared types for AudioPlayer components.
 * Extracted to avoid circular dependencies between AudioPlayer and its child components.
 */

import SvgIcon from '@mui/material/SvgIcon';
import type { Theme } from '@mui/material/styles';

export interface IAudioPlayerClassNameProps {
    root: string;
    playIcon: string;
    volumeIcon: string;
    muteIcon: string;
    mainSlider: string;
    volumeSliderContainer: string;
    volumeSlider: string;
    downloadsIcon: string;
    pauseIcon: string;
    loopIcon: string;
    progressTime: string;
    downloadsContainer: string;
    downloadsItemLink: string;
    downloadsItemText: string;
    closeIcon: string;
}

export interface IAudioPlayerColors {
    active: string;
    selected: string;
    disabled: string;
    hover: string;
}

export interface Icons {
    [key: string]: typeof SvgIcon;
}

export enum AudioPlayerComponentsOrder {
    standard = 'standard',
    reverse = 'reverse',
}

export enum AudioPlayerVariation {
    primary = 'primary',
    secondary = 'secondary',
    default = 'default',
}

export enum TimeOption {
    single = 'single',
    double = 'double',
}

export enum TimePosition {
    start = 'start',
    end = 'end',
}

export const getColors = (
    theme: Theme,
    variation: keyof typeof AudioPlayerVariation,
): IAudioPlayerColors => {
    if (variation === AudioPlayerVariation.default) {
        return {
            active: theme.palette.action.active,
            selected: theme.palette.action.selected,
            disabled: theme.palette.action.disabled,
            hover: theme.palette.action.hover,
        };
    } else {
        return {
            active: theme.palette[variation].main,
            selected: theme.palette[variation].dark,
            disabled: theme.palette[variation].light,
            hover: theme.palette[variation].light,
        };
    }
};
